import React from "react";

import "./raisecomplaint.css";

import { Complaint } from "app/components/complaint/Complaint";
import SecondaryWrapper from "app/components/secondary-wrapper/SecondaryWrapper";

function RaiseComplaint() {
  return (
    <SecondaryWrapper title="Raise Complaint">
      <Complaint />
    </SecondaryWrapper>
  );
}

export default RaiseComplaint;
